import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

/**
 * Recargas a dispositivos. Query propia (no generada por codegen, que solo escanea
 * los `.graphql`). Alineada con `Query.portalDeviceRecharges` del gateway, que solo
 * acepta paginación (`take`/`skip`) — no filtro por estado ni rango de fecha.
 */
const RECHARGES = gql`
  query PortalDeviceRecharges(
    $businessId: String!
    $take: Int
    $skip: Int
  ) {
    portalDeviceRecharges(
      businessId: $businessId
      take: $take
      skip: $skip
    ) {
      items {
        id
        amount
        currencyId
        phoneNumber
        countryCode
        observations
        isConfirmed
        deviceId
        registeredByUserId
        registeredBy
        createdAt
      }
      totalItems
    }
  }
`

export interface DeviceRecharge {
  id: number
  amount: number
  currencyId?: number | null
  phoneNumber: string
  countryCode: string
  observations?: string | null
  isConfirmed: boolean
  deviceId?: string | null
  registeredByUserId?: string | null
  registeredBy?: string | null
  createdAt?: string | null
}

interface RechargesResult {
  portalDeviceRecharges: { items: DeviceRecharge[]; totalItems: number }
}

interface UseDeviceRechargesArgs {
  businessId: string | undefined
  take: number
  skip: number
}

/** Historial paginado de recargas a dispositivos. */
export function useDeviceRecharges({
  businessId,
  take,
  skip,
}: UseDeviceRechargesArgs) {
  const { data, loading, error, refetch } = useQuery<RechargesResult>(RECHARGES, {
    variables: {
      businessId: businessId ?? '',
      take,
      skip,
    },
    skip: !businessId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    recharges: data?.portalDeviceRecharges.items ?? [],
    totalItems: data?.portalDeviceRecharges.totalItems ?? 0,
    loading,
    error,
    refetch,
  }
}
